import { findBestMatchedUser } from "../utils/findBestMatchedUser.js";
import { getDataFactoryUserAdvancedList } from "./getDataFactoryUserAdvancedList.js";
export const getDataFactoryUserAdvanced = async (customerInput, client) => {
    const data = await getDataFactoryUserAdvancedList(customerInput, client);
    if (!data || data.length === 0) {
        return null;
    }
    return findBestMatchedUser(customerInput, data);
};
